export const RESOURCE_MATCH_POPOVER_BUTTON_ACTION = {
  ACCEPT: 'ACCEPT',
  PROPOSE: 'PROPOSE'
};

export default RESOURCE_MATCH_POPOVER_BUTTON_ACTION;
